<template>
  <div>
    <img
      src="/images/other/payment/zpay88Tutorial.jpg"
      width="100%"
      usemap="#image-map"
    />

    <map name="image-map">
      <area
        target=""
        alt=""
        title=""
        href="https://88pay.fun/"
        coords="1776,525,1006,326"
        shape="rect"
      />
    </map>
  </div>
</template>

<script>
export default {
  mounted() {
    imageMapResize();
  },
};
</script>
